// extracted by mini-css-extract-plugin
module.exports = {"root":"lottie-section-module--root--SpN_Q","disablePadding":"lottie-section-module--disablePadding--3qmr3"};